module.exports = __webpack_public_path__ + "img/p1.d9069398.png";